// smithy-typescript generated code
import { ServiceException as __ServiceException, } from "@smithy/smithy-client";
export { __ServiceException };
/**
 * @public
 *
 * Base exception class for all service exceptions from Apiv2 service.
 */
export class Apiv2ServiceException extends __ServiceException {
    /**
     * @internal
     */
    constructor(options) {
        super(options);
        Object.setPrototypeOf(this, Apiv2ServiceException.prototype);
    }
}
